import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '@app/data/common-imports';
import { NodeService } from '@app/data/services';

@Component({
  selector: 'app-blank-layout',
  templateUrl: './blank.component.html',
  styleUrls: ['./blank.component.scss']
})
export class BlankComponent implements OnInit, OnDestroy {
  public get isDesktop(): boolean { return this.node.isAvailable(); }
  public version = environment.version;
  public isMaximized = false;
  public isFullScreen = false;
  private currentWindow: any = null;
  private readonly handleMaximize = () => this.isMaximized = true;
  private readonly handleUnmaximize = () => this.isMaximized = false;
  private readonly handleEnterFullScreen = () => this.isFullScreen = true;
  private readonly handleLeaveFullScreen = () => this.isFullScreen = false;

  constructor(private node: NodeService) {
  }

  public ngOnInit(): void {
    if (!this.node.isAvailable()) return;
    this.currentWindow = this.node.remote.getCurrentWindow();
    this.isMaximized = this.currentWindow.isMaximized();
    this.isFullScreen = this.currentWindow.isFullScreen();
    this.currentWindow.on('maximize', this.handleMaximize);
    this.currentWindow.on('unmaximize', this.handleUnmaximize);
    this.currentWindow.on('enter-full-screen', this.handleEnterFullScreen);
    this.currentWindow.on('leave-full-screen', this.handleLeaveFullScreen);
  }

  public ngOnDestroy(): void {
    if (!this.currentWindow) return;
    this.currentWindow.removeListener('maximize', this.handleMaximize);
    this.currentWindow.removeListener('unmaximize', this.handleUnmaximize);
    this.currentWindow.removeListener('enter-full-screen', this.handleEnterFullScreen);
    this.currentWindow.removeListener('leave-full-screen', this.handleLeaveFullScreen);
  }

  public closeWindow() {
    if (this.node.isAvailable()) {
      this.node.remote.getCurrentWindow().close();
    }
  }

  public minimizeWindow() {
    if (this.node.isAvailable()) {
      this.node.remote.getCurrentWindow().minimize();
    }
  }

  public toggleWindowMaximize(): void {
    if (!this.node.isAvailable()) return;
    const window = this.node.remote.getCurrentWindow();
    if (window.isFullScreen()) {
      window.setFullScreen(false);
      return;
    }
    window.isMaximized() ? window.unmaximize() : window.maximize();
  }
}
